import { useState } from "react";
import AdminPageHeader from "@/components/admin/AdminPageHeader";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { changePassword } from "@/lib/auth";

export default function ChangePassword() {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");

    const onSubmit = (e) => {
        e.preventDefault();
        setError("");
        if (next !== confirm) {
            setError("New password and confirmation do not match.");
            return;
        }
        const res = changePassword(current, next);
        if (!res.ok) {
            setError(res.error);
            return;
        }
        toast.success("Password updated.");
        setCurrent("");
        setNext("");
        setConfirm("");
    };

    return (
        <div data-testid="admin-change-password-page">
            <AdminPageHeader
                eyebrow="Modules / Security"
                title="Change password"
                description="Update your admin password. Choose something you'll actually remember."
            />

            <form
                onSubmit={onSubmit}
                data-testid="change-password-form"
                className="max-w-lg mx-auto px-6 md:px-10 py-10 space-y-6"
            >
                <div className="bg-white border border-[#0F1F38]/10 p-6 md:p-8 space-y-5">
                    <Row
                        label="Current password"
                        value={current}
                        onChange={setCurrent}
                        testid="input-current-password"
                    />
                    <Row
                        label="New password"
                        value={next}
                        onChange={setNext}
                        testid="input-new-password"
                    />
                    <Row
                        label="Confirm new password"
                        value={confirm}
                        onChange={setConfirm}
                        testid="input-confirm-password"
                    />
                    {error && (
                        <div
                            data-testid="change-password-error"
                            className="text-sm text-red-700 border-l-2 border-red-700 pl-3"
                        >
                            {error}
                        </div>
                    )}
                </div>

                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        data-testid="change-password-submit"
                        className="px-6 h-11 bg-[#0F1F38] text-[#F7F5F0] text-xs tracking-label uppercase font-semibold hover:bg-[#1A3254] transition-colors"
                    >
                        Update password
                    </button>
                </div>
            </form>
        </div>
    );
}

function Row({ label, value, onChange, testid }) {
    return (
        <div>
            <Label className="text-[10px] tracking-label uppercase text-[#0F1F38]/60">
                {label}
            </Label>
            <Input
                type="password"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                data-testid={testid}
                required
                className="mt-2 h-11 rounded-none border-[#0F1F38]/20"
            />
        </div>
    );
}
